import React, { useEffect, useRef, useState } from "react";
import { getAllCards, createContact } from "../../constants";
import { ToastContainer, toast } from "react-toastify";

const ModalAddContactFromCard = ({ user, cardId }) => {
  const [cards, setCards] = useState([]);
  const [indexCard, setIndexCard] = useState(0);
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(0);
  const steps = ["confirmation", "select card", "added"];

  const handleAddContact = (e, user, setStep) => {
    setLoading(true);
    e.preventDefault();
    const token = user.access_token;
    const data = {
      user_card_id: cards[indexCard].card_id,
      user_connection_card_id: cardId,
      connection_type: "LIVE",
    };
    createContact(token, data, setLoading, null, setStep);
  };

  useEffect(() => {
    if (step == 2) {
      setTimeout(() => {
        setCards([]);
        setStep(0);
        document.getElementById("add_contact_modal").close();
      }, 4000);
    }
  }, [step]);
  return (
    <dialog id="add_contact_modal" className="modal shadow-2xl">
      <ToastContainer />
      <div className="modal-box flex flex-col justify-between max-w-none w-full md:w-[500px] p-10 gap-4 h-fit items-center">
        <div className="flex flex-col gap-5 font-bold text-[16px]">
          {step == 0
            ? "Do you want to add this card to Contact?"
            : step == 1
              ? "Select your card"
              : "This card is added to you Contacts successfully"}
        </div>
        {step == 1 && (
          <div className="flex flex-col gap-4 items-center w-full">
            <select
              id="cards"
              className="bg-white border border-gray-400 text-gray-900 rounded-lg focus:outline-blue-500 focus:border-blue-500 block px-3 py-2 w-full"
              value={indexCard}
              onChange={(e) => setIndexCard(e.target.value)}
            >
              {cards.length > 0 ? (
                cards.map((val, ind) => (
                  <option key={ind} value={ind}>
                    {val.card_name}
                  </option>
                ))
              ) : (
                <option>Card</option>
              )}
            </select>
          </div>
        )}
        {step <= 1 && (
          <div className="flex flex-row justify-center gap-10">
            <div
              onClick={(e) => {
                e.preventDefault();
                if (step == 1) {
                  setStep(step - 1);
                } else {
                  document.getElementById("add_contact_modal").close();
                }
              }}
              className="flex flex-col border border-primary text-primary rounded-lg hover:bg-gray-100 cursor-pointer px-10 py-2"
            >
              {step == 0 ? "No" : "Back"}
            </div>
            <div
              onClick={(e) => {
                e.preventDefault();
                if (step == 0) {
                  const token = user.access_token;
                  getAllCards(token, setCards);
                  setStep(step + 1);
                }
                if (step == 1 && cards.length > 0) {
                  handleAddContact(e, user, setStep);
                }
              }}
              className={`flex flex-col text-white rounded-lg ${cards.length > 0 || step == 0 ? "bg-primary hover:bg-tertiary cursor-pointer" : "bg-gray-200 cursor-disabled"} px-10 py-2`}
            >
              {step == 0 ? (
                "Yes"
              ) : loading ? (
                <div role="status">
                  <svg
                    aria-hidden="true"
                    className="w-6 h-6 text-gray-200 animate-spin fill-secondary"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="white"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="#E47410"
                    />
                  </svg>
                  <span className="sr-only">Loading...</span>
                </div>
              ) : (
                "OK"
              )}
            </div>
          </div>
        )}
        {step == 2 && (
          <div
            onClick={(e) => {
              e.preventDefault();
              setCards([]);
              document.getElementById("add_contact_modal").close();
              setStep(0);
            }}
            className="flex flex-col bg-primary text-white rounded-lg hover:bg-tertiary cursor-pointer px-10 py-2"
          >
            OK
          </div>
        )}
        <div className="flex flex-row w-full justify-center gap-2" id="steps">
          {steps.map((v, i) => (
            <div
              className={`flex flex-col rounded-full w-2 h-2 ${i <= step ? "bg-primary" : "bg-gray-200"}`}
            ></div>
          ))}
        </div>
      </div>
      <form method="dialog" className="modal-backdrop">
        <button>close</button>
      </form>
    </dialog>
  );
};

export default ModalAddContactFromCard;
